import { BaseSymbol } from "./base";

export function lineV(ctx, r, x, y, z) {
    return ctx.moveTo(x, y - r), ctx.lineTo(x, y + r), !0;
}

export class LineVSymbol extends BaseSymbol {
    constructor() {
        super(...arguments), this.type = "lineV", this.pathStr = "M0,-0.5L0,0.5";
    }
    draw(ctx, size, x, y, z) {
        return lineV(ctx, this.parseSize(size) / 2, x, y, z);
    }
    drawOffset(ctx, size, x, y, offset, z) {
        return lineV(ctx, this.parseSize(size) / 2 + offset, x, y, z);
    }
    drawToSvgPath(size, x, y, z) {
        const r = this.parseSize(size) / 2;
        return `M ${x}, ${y - r} L ${x},${y + r}`;
    }
}

export default new LineVSymbol;
//# sourceMappingURL=line-v.js.map
